'use strict';

import * as Props from '../Props';

const angular = require('angular');

const TextareaProperties = {
    Basic: {
        'ControlType': 'Textarea',
        'Label': {
            name: 'label',
            selectedValue: 'Text-Area',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Text_Area'),
        'Data Field Name': Props.getDataFieldName('Text_Area'),  
        'Value': {
            name: 'value',
            selectedValue: '',
            type: 'textbox',
            onClickFunction: 'existingDataField',
            addOnButton: 'fa fa-function',
            onChangeFunction: 'updateDSField'
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        /*'Default': {
            name: 'Default',
            selectedValue: '',
            type: 'textbox'
        },*/
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Validate': {
            name: 'format',
            type: 'dd',
            disable: false,
            options: [
                {
                    key: 'Please Select',
                    value: ''
                },
                {
                    key: 'Integer',
                    value: 'Integer'
                },
                {
                    key: 'Decimal',
                    value: 'Decimal'
                },
                {
                    key: 'Letters-and-Numbers',
                    value: 'Alphanumeric'
                },
                {
                    key: 'Letters',
                    value: 'Letters'
                },
                {
                    key: 'Email',
                    value: 'Email'
                }
            ],
            selectedValue: '',
            onChangeFunction:'onFormatTypeChanged'
        },
        'DigitSeparator': {
            name: 'digit.separator',
            type: 'checkbox',
            selectedValue: false,
            onChangeFunction: 'onDigitSepratorToggle',
            onClickFunction: 'openLanguageDialogForNumberSeparator',
            addOnButton: 'fa fa-globe digit-separator-global-icon hidden',
            extraClass: 'child-1',
            hidden: true
        },
        'DecimalPlaces': {
            name: 'decimal.places',
            type: 'dd',
            extraClass: 'child-1',
            options: [
                {
                    key: '0',
                    value: '0'
                },
                {
                    key: '1',
                    value: '1'
                },
                {
                    key: '2',
                    value: '2'
                },
                {
                    key: '3',
                    value: '3'
                },
                {
                    key: '4',
                    value: '4'
                },
                {
                    key: '5',
                    value: '5'
                },
                {
                    key: '6',
                    value: '6'
                },
                {
                    key: '7',
                    value: '7'
                },
                {
                    key: '8',
                    value: '8'
                },
                {
                    key: '9',
                    value: '9'
                }
            ],
            selectedValue: '0',
            hidden: true
        },
        'DecimalThousandSeparator':{
            selectedValue: {
                Default : {
                    displayCountry: "Default",
                    displayLanguage: "Default",
                    languageId: "Default",
                    decimal: ".",
                    thousand: ",",
                }
            },
            extraClass: 'child-1',
            hidden:true 
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Place Holder': {
            name: 'place.holder',
            selectedValue: '',
            type: 'textbox'
        },
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'HasMic': {
            name: 'show.mic',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Validate': {
            name: 'validate',
            type: 'dd',
            disable: false,
            options: [
                {
                    key: 'Please Select',
                    value: ''
                },
                {
                    key: 'Integer',
                    value: 'Integer'
                },
                {
                    key: 'Decimal',
                    value: 'Decimal'
                },
                {
                    key: 'Letters-and-Numbers',
                    value: 'Alphanumeric'
                },
                {
                    key: 'Letters',
                    value: 'Letters'
                },
                {
                    key: 'Email',
                    value: 'Email'
                }
            ],
            selectedValue: ''
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: angular.copy(Props.elementEventsObject)
};

export default TextareaProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Textarea.ts